import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewsComponent } from './news.component';
import { NewsBlockModule } from '@news/views/news-block/news-block.module';
import { NewsBlockSocialModule } from 'app/news/views/news-block-social/news-block-social.module';
import { NewsGQL } from '@shared/services/news/news.gql.service';
import { NgScrollbarModule } from 'ngx-scrollbar';

import { NewsHeaderModule } from './news-header/news-header.module';

import { PagedVirtualScrollerModule } from '@shared/components/paged-virtual-scroller/paged-virtual-scroller.module';
import { PortalEventsGQL } from 'app/shared/services/portal-events/graphql/portal-events.gql.service';

import { NewsRoutingModule } from './news-routing.module';

import { NewsHeaderResponsiveModule } from './news-headerResponsive/news-headerResponsive.module';
import { ToolbarHallsComponent } from 'app/layout/components/toolbar-halls/toolbar-halls.component';
import { CarouselBannerComponent } from 'app/shared/components/carousel-banner/carousel-banner.component';

@NgModule({
    imports: [
    CommonModule,
    NgScrollbarModule,
    NewsBlockModule,
    NewsBlockSocialModule,
    NewsHeaderModule,
    ToolbarHallsComponent,
    PagedVirtualScrollerModule,
    NewsRoutingModule,
    CarouselBannerComponent,
    NewsHeaderResponsiveModule,
    NewsComponent
],
    providers: [
        NewsGQL,
        PortalEventsGQL
    ],
})
export class NewsModule { }
